import React,{ useState, useEffect } from 'react';
import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';
import {  useHistory,useRouteMatch } from 'react-router-dom';

// Components
import StyledPageContent from '../components/StyledPage';
import Loading from '../components/Loading';
import Button from '../components/Button';
import FormErrors, { trowError } from '../components/FormErrors';
import AcreditacionProfile, { LIST_ABONOS_PROFILE } from '../models/AcreditacionProfile';
import { GET_EVENT_PROFILE_ASIST, CREATE_PROFILE_EVENT_ASIST }  from '../models/Eventos';



// Assets



const StyledPage = styled(StyledPageContent)`
  display: grid;
  height: 100%;
  .login-wrapper {
    max-width: 1024px;
    width:100%;
    margin: auto;
    padding: 4rem;
  }
`

const FormStyled = styled.main`
  form{
    margin-bottom: 0px;
  }
  button{
    text-transform:uppercase;
    height: 55px;
  }
`;

interface MatchParams{
    event_uuid:string
}
export default  () => {
    const history = useHistory();
    const { params } = useRouteMatch<MatchParams>();
    let UserInfo=AcreditacionProfile.getProfile();

    const [ registerProfileEvent, { loading } ] = useMutation(CREATE_PROFILE_EVENT_ASIST);
    const [ getListAbonosProfile,{ data:dataListAbonos, loading:loadingListAbonos } ] = useMutation(LIST_ABONOS_PROFILE);

    const { register, handleSubmit, errors:errorsForm } = useForm();
    const [showConfirm,setShowConfirm] = useState(false);

    const [submitError,setSubmitError] = useState<null|string>(null);
    const onSubmit = async (data:any) => {
        console.log('on Send data:',data);
        setSubmitError(null);
        
        try{
            let response=await registerProfileEvent({ 
                variables:{
                    profile_uuid:UserInfo.uuid,
                    input:{
                        event_id:params.event_uuid,
                        tickets_no:parseInt(data.cantiad)
                    } 
                }
            });
            if(response.errors)
                throw new trowError(response.errors);

            console.log(response);
            setShowConfirm(true);

        }catch(e){
            console.error(e);
            setSubmitError(e);
        }
    }

    useEffect(() => {
        (async () => {

            await getListAbonosProfile({
                variables:{
                    profile_uuid:UserInfo.uuid
                }
            });

        })();
    },[]);

    const { loading:loadingEvent, error, data:dataEvent } = useQuery(GET_EVENT_PROFILE_ASIST,{
        variables:{
            event_id:params.event_uuid,
            profile_uuid:UserInfo.uuid
        }
    });

    
    if(loadingEvent || loadingListAbonos)
        return <Loading />

    const evetentData=dataEvent?.getEvent;
    const abonosData=dataListAbonos?.listAbonos
    const showScreenConfirm=showConfirm || dataEvent?.getEventsProfileAsist!==null;


    return (
        <StyledPage>
            <FormStyled className="login-wrapper">
                {!showScreenConfirm?
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="d-flex">
                            <div className='col-12'>
                                <div className="title text-center">{evetentData.nombre}</div>
                            </div>
                        </div>
                        <br />
                        {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}
                        <br />
                        <div className="d-flex flex-wrap">
                            <div className='col-12'>
                                <p>¡Hola {UserInfo.name}!</p>
                            </div>
                        </div>
                   
                      
                        <br />
                        <div className="d-flex flex-wrap">
                            <div className='col-12 col-sm-4'>
                                <strong>Descripcion del evento:</strong>
                            </div>
                            <div className='col-12 col-sm-8'>{evetentData.alt}</div>

                        </div>
                        <br />
                        <div className="d-flex flex-wrap">
                            <div className='col-12'>
                          Al contar con <strong>{abonosData?.total} abono(s)</strong>, pueden asistir un total de <strong>{abonosData?.total} persona(s)</strong> a este evento.
                            </div>
                        </div>
                        <br />
                        <div className="d-flex flex-wrap">
                            <div className='col-12 col-sm-8'>
                                <strong>¿Cuantas personas asistirán a este evento?</strong>
                            </div>
                            <div className='col-12 col-sm-4'>
                                <select className="form-control" name="cantiad"  ref={register} >
                                    {Array.from(Array(abonosData?.total), (e, i) => (
                                        <option value={i+1}>{i+1}</option>
                                    ))}
                                </select>
                            </div>

                        </div>

                        <br/>
                        <div className="d-flex flex-wrap">
                            <div className='col-12'>
                                <strong>Te recordamos que para este evento es necesario ingresar con cubrebocas y traer tu propio plumón para los autógrafos.</strong>
                            </div>
                        </div>

                        <br/>   <br/>

                        <div className="d-flex">
                            <div className='col-12 text-center'>
                                <Button disabled={loading} className="important red-btn ">GUARDAR</Button>
                            </div>
                        </div>
                    </form>
                    :<>
                        <h2>¡Ya estás registrado para el evento! </h2>
                        <p>Te pedimos por favor seas puntual, y lleves contigo tu mica física o digital de abonado para tener acceso. </p>
                        <p>Si tienes dudas mándanos un WhatsApp al 444-111-8872. </p>
                        <p>¡Nos vemos pronto!</p>
                    </>
                }
            </FormStyled>
        </StyledPage>
    )
}